import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/product_mold_relation',
    name: 'POST_PRODUCT_MOLD',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
